import React, { useState, useCallback } from "react";
import { Pertanyaan } from "../types/Teleconsultation";
import {
  getDisclaimer,
  saveDisclaimer,
} from "../services/teleconsultationDisclaimerService";

export const useTeleconsultationDisclaimer = () => {
  const [pertanyaan, setPertanyaan] = useState<Pertanyaan>(getDisclaimer());

  const updateField = useCallback((name: string, value: string) => {
    setPertanyaan(prev => {
      const updated = { ...prev, [name]: value };
      saveDisclaimer(updated);
      return updated;
    });
  }, []);

  const save = useCallback(() => {
    saveDisclaimer(pertanyaan);
  }, [pertanyaan]);

  return {
    pertanyaan,
    updateField,
    save,
  };
};